import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import Pagination from 'bulma-pagination-react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import queryString from 'querystring'

import {
  createPortal,
  fetchTowns,
  deletePortal,
  fetchPortalWithQuery,
} from '../../../modules/portal-remote/portalService'
import MobileHome from './MobileHome'
import { CURRENT_TOWN } from '../../../config'
import { removePortalImages } from '../../../modules/portal-remote/portalImageService'
import withParams from '../../../modules/router-manage/withParams'
import MobilePortalSearch from './MobilePortalSearch'
import MobilePortalList from './MobilePortalList'

export const requestDeletePortal = async portal => {
  if (window.confirm(`Are you sure delete ${portal.title} ?`)) {
    let imageList = []

    if (portal.imageStores) {
      imageList.push(...portal.imageStores)
    }

    if (portal.galleryImages) {
      imageList.push(...portal.galleryImages)
    }

    if (portal.mainImageId) {
      imageList.push(portal.mainImageId)
    }

    let imageResult
    if (!_.isEmpty(imageList)) {
      imageResult = await removePortalImages(portal._id, imageList)
    }

    const portalResult = await deletePortal(portal)
    toast.success(`Delete ${portal.title} success!`)
    console.log('Delete result', portalResult, imageResult)
  }
}
class MobileHomeContainer extends React.Component {
  state = {
    filter: {
      title: '',
    },
    pageCount: null,
  }
  componentDidMount() {
    this.setFilter(this.props.params, () => {
      this.handleFetchPortals(this.state.filter)
    })
  }

  async componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.params, prevProps.params)) {
      console.log(
        'did update',
        this.props.params,
        prevProps.params,
        this.state.filter,
      )
      try {
        this.setFilter(this.props.params, () => {
          this.handleFetchPortals(this.state.filter)
        })
      } catch (error) {
        toast.error('fetch error', error.message)
      }
    }
  }

  setFilter(params, callback) {
    const filter = _.pick(params, ['title', 'tags', 'page', 'limit'])
    const page = _.parseInt(filter.page) || 1
    this.setState({ filter: { ...filter, page } }, callback)
  }

  handleFetchPortals = async params => {
    try {
      const { data, pageCount, limit } = await fetchPortalWithQuery(params)
      this.setState({ portals: data, pageCount, limit })
    } catch (error) {
      toast.error('Fetch Portal Error' + error.message)
    }
  }

  isNotEmpty = value => !_.isEmpty(value)

  handleCreatePortal = async title => {
    try {
      return await createPortal({ title })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleDeletePortal = async portal => {
    try {
      await requestDeletePortal(portal)
      this.handleFetchPortals(this.props.params)
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleSubmitPortal = async portal => {
    let portalID = portal._id
    if (!portalID) {
      console.info('create portal from BE by portalName', portal)
      portal = await this.handleCreatePortal({ th: this.state.filter.title })
      portalID = portal._id
    }

    if (portalID) {
      this.props.routeToMobileFormPage(portalID)
    }
  }

  createQueryString(newParams = {}) {
    const params = {
      ...this.props.params,
      ...newParams,
    }
    return queryString.stringify(params)
  }

  replacePage = (newParams = {}) => {
    this.props.history.replace(`?${this.createQueryString(newParams)}`)
  }

  handlePageChange = page => {
    if (page > 0) {
      this.replacePage({ page })
    }
  }

  handleSearch = value => {
    console.log(
      'handle search ',
      this.createQueryString({
        title: value,
      }),
    )
    this.props.history.replace(
      `?${this.createQueryString({
        title: value,
      })}`,
    )
  }

  handleSearchTextChange = value => {
    this.setFilter({ title: value })
  }

  render() {
    const currentPage =
      _.chain(this.props)
        .get('params.page')
        .toNumber()
        .value() || 1

    if (this.state.portals) {
      return (
        <React.Fragment>
          <div style={{ paddingTop: 8, paddingBottom: 8 }}>
            {this.state.pageCount && (
              <Pagination
                pages={this.state.pageCount}
                currentPage={currentPage}
                onChange={this.handlePageChange}
              />
            )}
          </div>
          <nav className="panel">
            <div className="panel-heading">Mobile Portal Search</div>
            <MobilePortalSearch
              filter={this.state.filter}
              onSearch={this.handleSearch}
              onPortalSearchTextChange={this.handleSearchTextChange}
            />
            <MobilePortalList
              filter={this.state.filter}
              isAdmin={this.state.isAdmin}
              onPortalCreate={this.handleSubmitPortal}
              onPortalDelete={this.handleDeletePortal}
              onPortalSelect={this.handleSubmitPortal}
              portals={this.state.portals}
            />
          </nav>
        </React.Fragment>
      )
    } else {
      return null
    }
  }
}

export default compose(
  withRouter,
  withParams,
)(MobileHomeContainer)



// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/MobileHomeContainer.js